import Image from 'next/image';

const NextImage = ({ ...props }) => {
  return <Image {...props} />;
};

export default NextImage;
